import { Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { filter, Observable, take } from 'rxjs';

import { SurveyCreationCoreApiActions } from '../survey-creation-core.actions';

export function saveSucceeded$(actions$: Actions): Observable<Action> {
  return actions$.pipe(
    ofType(
      SurveyCreationCoreApiActions.saveSurveySuccess,
      SurveyCreationCoreApiActions.saveSurveyFailure,
    ),
    take(1),
    filter(
      ({ type }) =>
        type === SurveyCreationCoreApiActions.saveSurveySuccess.type,
    ),
  );
}
